import { TableSortConfiguration } from '@platform-workspace/design-system';
import { SORT_TYPE_MAP } from '@shared/utils/constants';
import { SortModelItem } from 'ag-grid-community';

export const toSortDto = ({ selectedColumn, sortType }: TableSortConfiguration): string | null => {
  if (sortType === null) {
    return null;
  }

  const direction = SORT_TYPE_MAP[sortType];

  return `${selectedColumn},${direction}`;
};

export const toSortAgGridParam = (sorts: SortModelItem[]): string | null => {
  if (!sorts?.length) return null;

  return sorts.map((sort) => `${sort.colId},${sort.sort}`).join(',');
};
